import React from "react";
import { Box, Tooltip } from "@chakra-ui/react";
import { boundsOf, DIRECTIONS } from "../boardGeometry";
import { STANDE } from "../../standeTokens";
import { c } from "../../classroomColors";

const SIZE = 22;
const OFFSET = 13; // how far the handle floats outside the item's edge

/**
 * The four plus buttons around a hovered item.
 *
 * Chaining is the quick path — place one note, then keep pressing plus — so
 * the handles are positioned from the item's own bounds and never enter the
 * board model. Clicking one is the only thing they do; the canvas decides
 * what gets created.
 */
const AddHandles = ({ item, onAdd }) => {
  const b = boundsOf(item);

  const place = (d) => {
    if (d.dx === 0) {
      return {
        left: `${b.x + b.width / 2 - SIZE / 2}px`,
        top: `${d.dy < 0 ? b.y - SIZE - OFFSET : b.y + b.height + OFFSET}px`,
      };
    }
    return {
      top: `${b.y + b.height / 2 - SIZE / 2}px`,
      left: `${d.dx < 0 ? b.x - SIZE - OFFSET : b.x + b.width + OFFSET}px`,
    };
  };

  return (
    <>
      {DIRECTIONS.map((d) => (
        <Tooltip key={d.id} label={d.label} placement="top" hasArrow fontSize="11px" openDelay={400}>
          <Box
            as="button"
            type="button"
            aria-label={d.label}
            position="absolute"
            {...place(d)}
            boxSize={`${SIZE}px`}
            borderRadius="full"
            bg={c.surface}
            color={STANDE.black}
            border="1px solid"
            borderColor={c.border}
            boxShadow="0 2px 8px -3px rgba(0,0,0,0.35)"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="14px"
            lineHeight="1"
            fontWeight="500"
            cursor="pointer"
            zIndex={3}
            transition="transform 0.12s, background 0.12s"
            _hover={{ bg: STANDE.black, color: c.surface, transform: "scale(1.12)" }}
            _focusVisible={{ outline: "2px solid", outlineColor: STANDE.black, outlineOffset: "2px" }}
            // The canvas treats a press as "start something here"; this is a
            // button, not a placement.
            onPointerDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();
              onAdd(d);
            }}
          >
            +
          </Box>
        </Tooltip>
      ))}
    </>
  );
};

export default AddHandles;
